import React, { useState } from 'react'
import { renderMuiFormField } from 'utils/forms/renderMuiFormField'

import { selectData } from 'layouts/onboarding'
import ValuePoint from 'admin/components/ValuePoint'
import { Card, Grid, Typography, Collapse } from '@mui/material'
import { ExpandMore } from '@mui/icons-material'

function Military({
  collapseSections,
  toggleCollapse,
  intakeState,
  updateIntakeStateAtKey,
  updateIntakeStateAndSubmit,
}) {
  const [localForm, setLocalForm] = useState({
    militaryActiveDutyStartDate: intakeState.militaryActiveDutyStartDate || '',
    militaryActiveDutyEndDate: intakeState.militaryActiveDutyEndDate || '',
    militaryReservesStartDate: intakeState.militaryReservesStartDate || '',
    militaryReservesEndDate: intakeState.militaryReservesEndDate || '',
  })
  const handleChange = (field) => (value) => {
    setLocalForm((prev) => ({ ...prev, [field]: value }))
  }
  const showMilitary = intakeState?.military
  const showMilitaryReserves = intakeState?.militaryReserves

  return (
    <>
      <Grid item xs={12} md={4} xl={3}>
        <Card
          sx={{
            overflow: 'visible',
            textAlign: 'left',
            boxShadow: '0px 4px 25px -8px rgba(0,0,0,0.2)',
            backgroundColor: '#f8f9fa',
            borderRadius: 2,
            p: 2,
          }}
        >
          <Grid container columnSpacing={3} rowSpacing={2}>
            <Grid item xs={12}>
              <Typography variant="valueTitle">VALUE POINTS</Typography>
              <Collapse
                in={collapseSections.military}
                style={{ width: '100%' }}
              >
                {/* If Collecting a Military Active Duty Pension - Don't show military buyback */}
                {intakeState?.military && (
                  <>
                    {intakeState?.militaryActiveDutyPension ? (
                      <></>
                    ) : intakeState?.militaryPaidDeposit ? (
                      <></>
                    ) : (
                      <ValuePoint
                        text="Pursue Military-Time Buyback"
                        type="warning"
                      />
                    )}
                    {intakeState?.militaryReserves ? (
                      <ValuePoint text='Strategy - Talk about "Double-Dipping" rule' />
                    ) : (
                      <></>
                    )}
                  </>
                )}
              </Collapse>
            </Grid>
          </Grid>
        </Card>
      </Grid>

      <Grid item xs={12} md={8} xl={9}>
        <Card
          id="military"
          sx={{
            overflow: 'visible',
            textAlign: 'left',
            boxShadow: '0px 4px 25px -8px rgba(0,0,0,0.2)',
            borderRadius: 2,
            p: 2,
            pb: 0,
          }}
        >
          <Grid container columnSpacing={3} rowSpacing={2} pb={2}>
            <Grid
              item
              xs={12}
              onClick={() => toggleCollapse()}
              sx={{
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Typography variant="h4" sx={{ flexGrow: 1 }}>
                Military Service
              </Typography>
              <ExpandMore
                sx={{
                  height: '1.5em',
                  width: '1.5em',
                  transform: collapseSections.military
                    ? 'rotate(180deg)'
                    : 'rotate(0deg)',
                  transition: 'transform 0.3s ease-in-out',
                }}
              />
            </Grid>
          </Grid>
          <Collapse in={collapseSections.military} style={{ width: '100%' }}>
            <Grid container columnSpacing={3} rowSpacing={2} pb={2}>
              <Grid item xs={12} sm={6}>
                {renderMuiFormField({
                  autoFocus: false,
                  id: 'military',
                  label: 'Did you serve in the military?',
                  placeholder: '',
                  inputType: 'select',
                  value: intakeState.military,
                  onChange: updateIntakeStateAndSubmit((military) =>
                    updateIntakeStateAtKey({ military })
                  ),
                  options: selectData.yesNo,
                })}
              </Grid>
              {showMilitary ? (
                <>
                  <Grid item xs={12} sm={6}>
                    {renderMuiFormField({
                      autoFocus: false,
                      id: 'militaryBranch',
                      label: 'Military Branch',
                      placeholder: '',
                      inputType: 'select',
                      value: intakeState.militaryBranch,
                      onChange: updateIntakeStateAndSubmit((militaryBranch) =>
                        updateIntakeStateAtKey({ militaryBranch })
                      ),
                      options: selectData.militaryBranch,
                    })}
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    {renderMuiFormField({
                      autoFocus: false,
                      id: 'militaryActiveDutyPension',
                      label: 'Are you collecting an active duty pension?',
                      placeholder: '',
                      inputType: 'select',
                      value: intakeState.militaryActiveDutyPension,
                      onChange: updateIntakeStateAndSubmit(
                        (militaryActiveDutyPension) =>
                          updateIntakeStateAtKey({
                            militaryActiveDutyPension,
                          })
                      ),
                      options: selectData.yesNo,
                    })}
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Grid container columnSpacing={3} rowSpacing={2} pt={1}>
                      <Grid item xs={12} sm={6}>
                        {renderMuiFormField({
                          autoFocus: false,
                          id: 'militaryActiveDutyStartDate',
                          label: 'Active Duty Start Date',
                          inputType: 'date',
                          value: localForm.militaryActiveDutyStartDate,
                          onChange: (e) =>
                            handleChange('militaryActiveDutyStartDate')(e),
                          onBlur: updateIntakeStateAndSubmit(
                            (militaryActiveDutyStartDate) =>
                              updateIntakeStateAtKey({
                                militaryActiveDutyStartDate,
                              })
                          ),
                        })}
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        {renderMuiFormField({
                          autoFocus: false,
                          id: 'militaryActiveDutyEndDate',
                          label: 'Active Duty Discharge Date',
                          inputType: 'date',
                          value: localForm.militaryActiveDutyEndDate,
                          onChange: (e) =>
                            handleChange('militaryActiveDutyEndDate')(e),
                          onBlur: updateIntakeStateAndSubmit(
                            (militaryActiveDutyEndDate) =>
                              updateIntakeStateAtKey({
                                militaryActiveDutyEndDate,
                              })
                          ),
                        })}
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    {renderMuiFormField({
                      autoFocus: false,
                      id: 'militaryReserves',
                      label: 'Were you in the reserves?',
                      placeholder: '',
                      inputType: 'select',
                      value: intakeState.militaryReserves,
                      onChange: updateIntakeStateAndSubmit((militaryReserves) =>
                        updateIntakeStateAtKey({ militaryReserves })
                      ),
                      options: selectData.yesNo,
                    })}
                  </Grid>
                  {showMilitaryReserves && (
                    <>
                      <Grid item xs={12} sm={6}>
                        <Grid container columnSpacing={3} rowSpacing={2} pt={1}>
                          <Grid item xs={12} sm={6}>
                            {renderMuiFormField({
                              autoFocus: false,
                              id: 'militaryReservesStartDate',
                              label: 'Reserves Start Date',
                              inputType: 'date',
                              value: localForm.militaryReservesStartDate,
                              onChange: (e) =>
                                handleChange('militaryReservesStartDate')(e),
                              onBlur: updateIntakeStateAndSubmit(
                                (militaryReservesStartDate) =>
                                  updateIntakeStateAtKey({
                                    militaryReservesStartDate,
                                  })
                              ),
                            })}
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            {renderMuiFormField({
                              autoFocus: false,
                              id: 'militaryReservesEndDate',
                              label: 'Reserves Discharge Date',
                              inputType: 'date',
                              value: localForm.militaryReservesEndDate,
                              onChange: (e) =>
                                handleChange('militaryReservesEndDate')(e),
                              onBlur: updateIntakeStateAndSubmit(
                                (militaryReservesEndDate) =>
                                  updateIntakeStateAtKey({
                                    militaryReservesEndDate,
                                  })
                              ),
                            })}
                          </Grid>
                        </Grid>
                      </Grid>
                    </>
                  )}
                  <Grid item xs={12} sm={6}>
                    {renderMuiFormField({
                      autoFocus: false,
                      id: 'militaryPaidDeposit',
                      label: 'Paid deposit for active duty time ("Buyback")?',
                      placeholder: '',
                      inputType: 'select',
                      value: intakeState.militaryPaidDeposit,
                      onChange: updateIntakeStateAndSubmit(
                        (militaryPaidDeposit) =>
                          updateIntakeStateAtKey({
                            militaryPaidDeposit,
                          })
                      ),
                      options: selectData.yesNo,
                    })}
                  </Grid>
                </>
              ) : (
                <></>
              )}
            </Grid>
          </Collapse>
        </Card>
      </Grid>
    </>
  )
}

export default Military
